module.exports = __webpack_public_path__ + "static/media/logo.a1d6c373.png";